'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import { useTranslation } from '@/i18n';

export default function NotFound() {
    const { t, locale } = useTranslation();
    const router = useRouter();

    const handleGoHome = () => {
        router?.push('/');
    };

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="text-center max-w-md">
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
                    </div>
                </div>

                <h2 className="text-2xl font-medium text-onBackground mb-2">{t('publicWebsite:notFound.title') || (locale === 'ar' ? 'الصفحة غير موجودة' : 'Page Not Found')}</h2>
                <p className="text-onBackground/70 mb-8">
                    {t('publicWebsite:notFound.subtitle') || (locale === 'ar' ? 'الصفحة التي تبحث عنها غير موجودة. دعنا نعيدك إلى المكان الصحيح!' : "The page you're looking for doesn't exist. Let's get you back!")}
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleGoBack}
                        className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors duration-200"
                    >
                        <Icon name="ArrowLeftIcon" size={16} />
                        {t('publicWebsite:notFound.goBack') || (locale === 'ar' ? 'العودة للخلف' : 'Go Back')}
                    </button>

                    <button
                        onClick={handleGoHome}
                        className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-lg font-medium hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
                    >
                        <Icon name="HomeIcon" size={16} />
                        {t('publicWebsite:notFound.backToHome') || (locale === 'ar' ? 'العودة إلى الرئيسية' : 'Back to Home')}
                    </button>
                </div>
            </div>
        </div>
    );
}